import { createCompoundComponent } from '../../utilities/createCompoundComponent'
import { Tooltip as BaseTooltip } from './Tooltip'
import { Content } from './Content'
import { Trigger } from './Trigger'

export const Tooltip = createCompoundComponent(BaseTooltip, {
  Content,
  Trigger,
})
